var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import ThirdPartySystemService from '../../../api/ThirdPartySystemService';
import { auth } from "../../../helper/authDecorator";
import { nameDict } from "../../../constant/authCode";
import GoodList from './GoodList';
var Detail = (function (_super) {
    __extends(Detail, _super);
    function Detail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeName = '0';
        _this.warehouseId = null;
        _this.formData = {};
        return _this;
    }
    Detail.prototype.created = function () {
        this.service = ThirdPartySystemService.getInstance();
    };
    Detail.prototype.mounted = function () {
        var _this = this;
        var params = {
            agent_warehouse_id: this.warehouseId
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getDetail(params).then(function (res) {
            if (res.data.success) {
                _this.formData = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    Detail = __decorate([
        auth(nameDict["合作客户"]),
        Component({
            components: {
                'good-list': GoodList
            }
        })
    ], Detail);
    return Detail;
}(Vue));
export default Detail;
